export default "__VITE_ASSET__CgS15zLt__"